import { render, staticRenderFns } from "./healthConsult.vue?vue&type=template&id=6c8a4ffb&scoped=true&"
import script from "./healthConsult.vue?vue&type=script&lang=js&"
export * from "./healthConsult.vue?vue&type=script&lang=js&"
import style0 from "./healthConsult.vue?vue&type=style&index=0&id=6c8a4ffb&scoped=true&lang=css&"
import style1 from "./healthConsult.vue?vue&type=style&index=1&id=6c8a4ffb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8a4ffb",
  null
  
)

export default component.exports